export class ServerSideStateManager {
    constructor() {
        this.serializeStateCallbacks = new Map();
    }
    register(consumerId, serializeState) {
        this.serializeStateCallbacks.set(consumerId, serializeState);
    }
    serializeStates() {
        const serializedStatesByConsumerId = {};
        this.serializeStateCallbacks.forEach((serializeState, currentConsumerId) => {
            serializedStatesByConsumerId[currentConsumerId] = serializeState();
        });
        return encodeURI(JSON.stringify(serializedStatesByConsumerId));
    }
}
//# sourceMappingURL=server-side-state-manager.js.map